import type { InviteData, InvitePropertyPayload } from '@/types/auth'

function leaseDuration(value?: string) {
  if (!value) return undefined
  const match = String(value).match(/^\d{1,3}/)
  return match ? match[0] : undefined
}

function leaseDate(value?: string) {
  if (!value) return undefined
  const match = String(value).match(/^\d{4}-\d{2}-\d{2}/)
  return match ? match[0] : undefined
}

/**
 * Property object posted with registration.
 * Field names match the property-tab save payload.
 */
export function buildInvitePropertyPayload(
  invitation: InviteData | null | undefined,
  inviteCode: string,
  expectedResidents: number,
): InvitePropertyPayload {
  const otherIndividuals = expectedResidents > 1 ? '1' : '0'
  const payload: InvitePropertyPayload = {
    applied_property: '1',
    invite_code: inviteCode,
    expected_residents: expectedResidents,
    other_individuals: otherIndividuals,
  }

  if (invitation?.property_id) payload.fk_property_id = invitation.property_id
  if (invitation?.property_name) payload.property_name = invitation.property_name
  if (invitation?.property_address) payload.property_address = invitation.property_address
  if (invitation?.property_city) payload.property_city = invitation.property_city
  if (invitation?.property_state) payload.property_state = invitation.property_state
  if (invitation?.property_zipcode) payload.property_zipcode = invitation.property_zipcode
  if (invitation?.property_street_address) {
    payload.property_street_address = invitation.property_street_address
  }
  if (invitation?.rent_amount != null) {
    payload.rent_amount = invitation.rent_amount
  }
  const start = leaseDate(invitation?.lease_start_date)
  if (start) payload.lease_start_date = start
  const duration = leaseDuration(invitation?.lease_duration)
  if (duration) payload.lease_duration = duration
  if (invitation?.unit_number) payload.unit_number = invitation.unit_number
  if (invitation?.fk_user_id) payload.fk_agent_id = invitation.fk_user_id
  if (invitation?.agent_name) payload.agent_name = invitation.agent_name
  if (invitation?.agent_email) payload.agent_email = invitation.agent_email

  return payload
}
